import { useIntl } from 'react-intl'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import Sheet from 'components/utils/Sheet'
import LoyaltyTierPill from 'loyalty/components/LoyaltyTierPill'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import styled from 'styled-components'
import TriplePointTakeoverBackground from './TriplePointTakeoverBackground'

const TriplePointSheet = styled(Sheet)`
  position: relative;
  overflow: hidden;
`

const TileBackground = styled.div`
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
`

const Content = styled(Group)`
  position: relative;
  z-index: 1;
`

function TriplePointTakeoverSearchTileBanner() {
  const [tier] = useCurrentLoyaltyTier()
  const intl = useIntl()
  return <TriplePointSheet
    background="normal-background"
    padding={8}
    tabletPadding="12 16"
  >
    <TileBackground>
      <TriplePointTakeoverBackground />
    </TileBackground>
    <Content direction="horizontal" gap={16} verticalAlign="center">
      <LoyaltyTierPill tier={tier} kind="primary">
        {intl.formatMessage({
          id: 'H8LgZ-qRKJZ7AwSbqZAq',
          defaultMessage: 'Triple points',
          description: 'Loyalty tier pill label for triple points search tile banner',
        })}
      </LoyaltyTierPill>
      <BodyText variant="medium" weight="bold" colour={`tier-${tier}-contrast`}>
        {intl.formatMessage({
          id: 'a17zjk5rRgNf7R0nGv2m',
          defaultMessage: 'Limited-time offer on select packages',
          description: 'Search tile banner text for triple points limited-time offer',
        })}
      </BodyText>
    </Content>
  </TriplePointSheet>
}

export default TriplePointTakeoverSearchTileBanner
